module.exports = __webpack_public_path__ + "static/board_pic-a33add178f590560f93d9ef1fb2021c8.png";